<script setup lang="ts">
import { toastVariants } from '@satch-ui/primitives/toast/variants'

import { ToastLayout } from '@fond-of/fondof-ui'
import { CheckCircleIcon } from '@fond-of/satch-icons'
</script>

<template>
  <ToastLayout
    :class="
      toastVariants({
        variant: 'success',
      })
    "
  >
    <template #icon>
      <CheckCircleIcon class="size-5.5" />
    </template>

    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
  </ToastLayout>
</template>
